import { FC } from 'react';
import Link from 'next/link';
import { i18n as I18n } from 'utils/i18n';

interface Props {
  name: string;
  image: string;
  location: string;
  distance: number;
  url: string;
  component?: FC;
}

const VenueCard: FC<Props> = ({
  name,
  image,
  location,
  distance,
  url,
  component: Component = 'div',
}) => {
  return (
    <Component className="venue-card">
      <Link href={url}>
        <a>
          <img src={image} alt={name} className="venue-card__image" />
        </a>
      </Link>
      <h4 className="venue-card__name">
        <Link href={url}>
          <a>{name}</a>
        </Link>
      </h4>
      <p className="venue-card__location">{location}</p>
      <p className="venue-card__distance">
        <i className="fas fa-map-marker-alt" />
        {I18n.t('miles', { count: distance })}
      </p>
    </Component>
  );
};

export default VenueCard;
